import React, { Fragment } from 'react'
import { Menu as MenuUI, Transition } from '@headlessui/react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { MenuButtonUi, MenuButtonUiDark, MenuItemsClassesUi, MenuItemsProfileUi, Transitions } from './style'
import Icon from '@components/Icon'

const Menu = (props) => {
  const {
    children,
    underline,
    title,
    boldTitle = false,
    nowrap = false,
    dark = false,
    // itemOrigin = 'origin-top-right',
    align = 'right-[-10px]',
    truncate,
    scrollable = false,
  } = props

  return (
    <MenuUI as='div' className={'relative'}>
      {({ open }) => (
        <>
          <div>
            <MenuUI.Button
              className={classNames(
                underline,
                open ? 'text-secondaryGreen' : '',
                dark ? MenuButtonUiDark : MenuButtonUi
              )}
            >
              <span
                className={`${nowrap ? 'whitespace-nowrap' : null} ${
                  boldTitle ? 'font-bold' : null
                } mr-2 ${
                  truncate
                    ? 'truncate lg:max-w-[120px] max-w-[100px] xl:max-w-[170px]'
                    : ''
                }`}
              >
                {title}
              </span>
              <Icon icon={'Shevron'} rotate={open ? -90 : 90} />
            </MenuUI.Button>
          </div>

          <Transition
            show={open}
            as={Fragment}
            enter={Transitions.Enter}
            enterFrom={Transitions.EnterFrom}
            enterTo={Transitions.EnterTo}
            leave={Transitions.Leave}
            leaveFrom={Transitions.LeaveFrom}
            leaveTo={Transitions.LeaveTo}
          >
            <MenuUI.Items
              static
              className={classNames(
                MenuItemsProfileUi,
                align,
                scrollable && 'max-h-[60vh] overflow-y-auto'
              )}
            >
              {children}
            </MenuUI.Items>
          </Transition>
        </>
      )}
    </MenuUI>
  )
}

Menu.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  title: PropTypes.string,
  underline: PropTypes.bool,
  boldTitle: PropTypes.bool,
  nowrap: PropTypes.bool,
  scrollable: PropTypes.bool,
}

export default Menu
